import React from "react";

export const Pagination = ({ webhookevents, goto }) => {
	return (
		<div className="page-number">
			<div className="card flex-number">
				{webhookevents?.previous && (
					<p
						onClick={() =>
							goto(webhookevents?.previous_page_number)
						}
					>
						<i className="fas next active-two fa-angle-left" />
					</p>
				)}

				{webhookevents?.ellipse.map((page) =>
					page != null ? (
						<p
							className={
								webhookevents?.page === page ? "active-two" : ""
							}
							onClick={() => goto(page)}
						>
							{page}
						</p>
					) : (
						<p>...</p>
					),
				)}
				{webhookevents?.next && (
					<p onClick={() => goto(webhookevents?.next_page_number)}>
						<i className="fas next active-two fa-angle-right" />
					</p>
				)}
			</div>
		</div>
	);
};
